import React, { useState, useEffect } from "react";
import "../style/Counter.css";

const Inputs = ({ setGenders, setColors, setSizes }) => {
  const [gendersInput, setGendersInput] = useState(
    localStorage.getItem("genders") || ""
  );
  const [colorsInput, setColorsInput] = useState(
    localStorage.getItem("colors") || ""
  );
  const [sizesInput, setSizesInput] = useState(
    localStorage.getItem("sizes") || ""
  );

  useEffect(() => {
    setGendersInput(gendersInput);
    setColorsInput(colorsInput);
    setSizesInput(sizesInput);
    localStorage.setItem("genders", gendersInput);
    localStorage.setItem("colors", colorsInput);
    localStorage.setItem("sizes", sizesInput);
  }, [gendersInput, colorsInput, sizesInput]);

  return (
    <div className="texts-container">
      <div>
        <label className="label" htmlFor="genders-input">
          Genero:
        </label>
        <input
          className="input"
          id="genders-input"
          type="text"
          value={gendersInput}
          onChange={(e) => setGendersInput(e.target.value)}
        />
      </div>
      <div>
        <label className="label" htmlFor="colors-input">
          Colores:
        </label>
        <input
          className="input"
          id="colors-input"
          type="text"
          value={colorsInput}
          onChange={(e) => setColorsInput(e.target.value)}
        />
      </div>
      <div>
        <label className="label" htmlFor="sizes-input">
          Tallas:
        </label>
        <input
          className="input"
          id="sizes-input"
          type="text"
          value={sizesInput}
          onChange={(e) => setSizesInput(e.target.value)}
        />
      </div>
    </div>
  );
};

export default Inputs;
